export const STEPLISTSIDENAVMAP = {
  1: "INTEGRATION",
  2: "INTEGRATION",
  3: "INTEGRATION",
  4: "INTEGRATION",
  //    "5": "INTEGRATION",
  10: "INTEGRATION",
  13: "INTEGRATION",
  14: "INTEGRATION",
  15: "INTEGRATION",
  16: "INTEGRATION",
  5: "PUBLISH",
  6: "PUBLISH",
  7: "PUBLISH",
  11: "PRE BOARDING",
  12: "PUBLISH",
  17: "PRE BOARDING",
};
export const opsPageSteps = {
  1: {
    stepTitle: "Shipping Label",
    statusName: "uploadShippingLabel",
    stepOrder: "1",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: [
      "Ship Label Requested",
      "Partially Completed",
      "Ship Label Returned with errors",
    ],
    statusId: 5,
  },
  2: {
    stepTitle: "Order Testing",
    statusName: "orderTesting",
    stepOrder: "2",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: [
      "CH Testing",
      "810 Out for Review",
      "810 Returned with Errors",
      "810 Complete",
      "RDS Testing",
      "856 Out for Review",
      "856 Returned with Errors",
      "856 Complete",
      "EDI Testing",
      "Both Out for Review",
      "Both Returned with Errors",
      "",
      "",
      "",
    ],
    statusId: 6,
  },
  3: {
    stepTitle: "846 Testing",
    statusName: "eightFortySixTesting",
    stepOrder: "3",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: [
      "CH Testing",
      "RDS Testing",
      "EDI Testing",
      "852 In Process",
      "852 Pending for Later Date",
      "Return to vendor with errors",
    ],
    statusId: 7,
  },
  4: {
    stepTitle: "BOSS Agreement",
    statusName: "bossAgreement",
    stepOrder: "4",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: ["Yes - Pre-Approved", "No - Ineligible/Not Participating"],
    statusId: 8,
  },
  5: {
    stepTitle: "Vendor Line List",
    statusName: "completeVll",
    stepOrder: "5",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: ["Received from Vendor", "Off-Shore Creating Products"],
    statusId: 9,
  },
  6: {
    stepTitle: "Page Creation",
    statusName: "pageComplete",
    stepOrder: "6",
    fieldType: "radio",
    genericStatus: ["Not Started", "In Process", "Complete"],
    statusId: 10,
  },
  7: {
    stepTitle: "Live",
    statusName: "live",
    stepOrder: "7",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: [
      "Live Notifications to Vendor & Merchant",
      "Live Notifications to Internal teams (AP/MIO/MasterFile/Mtech/Stn Mtn Ops/CHUB)",
      "Complete Profile in Vendor Direct",
    ],
    statusId: 11,
  },
  10: {
    stepTitle: "Packing Slip",
    statusName: "uploadPackingSlip",
    stepOrder: "10",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: [
      "Packing Slip Requested",
      "Partially Completed",
      "Packing Slip Returned with errors",
    ],
    statusId: 4,
  },
  11: {
    stepTitle: "Review Contract",
    statusName: "uploadContract",
    stepOrder: "11",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: [
      "Review copy Sent",
      "Changes requested by vendor",
      "Sent to Legal for Review",
      "Second Round of edits sent to Legal",
      "Second Round of legal edits sent to vendor",
      "Returned to buyer for Signature",
      "Mailed to vendor",
      "Waiting Signature in Stone Mountain",
      "Leased Contract In Process",
      "Leased Contract complete",
      "CH Duns not Set - Mainframe",
      "CH Returned to Merchant with errors",
    ],
    statusId: 3,
  },
  12: {
    stepTitle: "Onboarding Complete",
    statusName: "onboardingComplete",
    stepOrder: "12",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    statusId: 23,
  },
  13: {
    stepTitle: "Table Setup",
    statusName: "tableSetup",
    stepOrder: "13",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: ["Reached out to vendor", "More info needed from vendor"],
    statusId: 25,
  },
  14: {
    stepTitle: "Quality Leader Approval",
    statusName: "qualityLeaderApproval",
    stepOrder: "14",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: ["Reached out to vendor", "More info needed from vendor"],
    statusId: 26,
  },
  15: {
    stepTitle: "EVP and ERP Setup",
    statusName: "evpAndErpSetup",
    stepOrder: "15",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: ["Reached out to vendor", "More info needed from vendor"],
    statusId: 27,
  },
  16: {
    stepTitle: "Item / SKU Setup",
    statusName: "itemOrSkuSetup",
    stepOrder: "16",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: ["Reached out to vendor", "More info needed from vendor"],
    statusId: 28,
  },
  17: {
    stepTitle: "UPS Account",
    statusName: "upsAccount",
    stepOrder: "17",
    fieldType: "checkbox",
    genericStatus: ["Not Started", "In Process", "Complete"],
    definedStatus: [
      "Form sent to vendor",
      "Form sent to UPS",
      "Assigned account info to vendor",
    ],
    statusId: 29,
  },
};
